
import { defineComponent } from 'vue'
import PatientDocuments from './PatientDocuments.vue'

export default defineComponent({
  name: 'PatientDetails',
  components: {
    PatientDocuments
  },
  data () {
    return {
      tab: null,
      gender: ['Female', 'Male', 'Other']
    }
  }
})
